export const V3_REFRESH_NOTIFICATION_SENT = 'V3-Refresh-Notification-Sent';
